<template>
    <div class="full-container d-flex justify-content-center align-items-center">

        <div class="login-container p-5">
            <form v-on:submit.prevent="onCreateUser">
                <div class="form-group">
                    <label for="exampleInputEmail1">Email address</label>
                    <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" v-model.trim="email">
                    <small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small>
                </div>
                <div class="form-group">
                    <label for="exampleInputPassword1">Password</label>
                    <input type="password" class="form-control" id="exampleInputPassword1" v-model.trim="password">
                </div>
                <button type="submit" class="btn btn-primary">Submit</button>
            </form>
        </div>

    </div>
</template>

<script>

    import firebase from 'firebase/app';
    import 'firebase/auth'

    export default {
        name: "Signup",

        data: () => {

            return {
                email: null,
                password: null
            }
        },

        methods: {
            onCreateUser() {

                firebase.auth().createUserWithEmailAndPassword(this.email, this.password)
                    .then(credentials => {
                        this.$router.replace('/app/dashboard');
                    })
                    .catch(error => {

                        concole.log(error);
                    });
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '~styles/container';
    @import '~styles/colors';

    .login-container {

        border-radius: 4px;
        border: 1px solid $border-color;
        -webkit-box-shadow: 0px 21px 55px -19px rgba(120,114,120,1);
        -moz-box-shadow: 0px 21px 55px -19px rgba(120,114,120,1);
        box-shadow: 0px 21px 55px -19px rgba(120,114,120,1);
        //background-color: $color-violet;
    }
</style>